import { ReduxState } from 'app/redux/types';

import { AllowingPricePreference } from '../constants';
import { selectPreferencesState } from './state';

// ---

export const selectSettingsActive = (state: ReduxState): boolean => {
  return selectPreferencesState(state).settingsActive;
};

export const selectOneClickBetActive = (state: ReduxState): boolean => {
  return selectPreferencesState(state).oneClickBetActive;
};

export const selectToAllowPricePreference = (state: ReduxState): AllowingPricePreference => {
  return selectPreferencesState(state).allowPricePreference;
};
